var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:{ bg_flat: _vm.isLogin }},[_c('Menu'),_c('router-view'),_c('Rodape')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }